import PrivacyDropdown from './PrivacyDropdown';

export default PrivacyDropdown;


// WEBPACK FOOTER //
// ./src/components/forms/PrivacyDropdown/index.js